import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Popper } from '@mui/material';
import React from 'react';

import { useDeferWrapperController } from './index.controller';
import { AllProps, DeferWrapperProps, ExpectedComponent } from './index.types';

export function DeferWrapperView<
  T,
  Props extends AllProps<T>,
  K extends ExpectedComponent<Props>,
>(props: DeferWrapperProps<T, Props, K>) {
  const { component: Component } = props;
  const { valueState, popperState, actions } = useDeferWrapperController(props);
  return (
    <Box position="relative">
      <Box ref={popperState.wrapperRef}>
        <Component
          {...({} as any)}
          {...props.componentsProps}
          value={valueState.internalValue}
          onChange={valueState.handleInternalChange}
        />
      </Box>

      <Popper
        open={Boolean(popperState.anchorEl) && valueState.hasPendingChanges}
        anchorEl={popperState.anchorEl}
        placement="top-end"
        sx={{ zIndex: 1300 }}
      >
        <IconButton
          size="small"
          onClick={actions.handleConfirm}
          title="Confirm changes"
        >
          <CheckIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          onClick={actions.handleRevert}
          title="Revert changes"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Popper>
    </Box>
  );
}
